import React from 'react';
import '../../styles/HeaderComponent.css';
import logo from '../../assets/logo.png';
import { useNavigate } from 'react-router-dom';

function HeaderComponent({ showLogo = false, showWeeklyButton = true }) {
  const navigate = useNavigate();
  
  return (
    <div className="header-container">
      {showLogo && (
        <div className="header-logo" onClick={() => navigate('/')}>
          <img src={logo} alt="Skidmore Dining" className="logo-image" />
        </div>
      )}
      <h1 className="header-title">Today's Menu</h1>
      <div className="header-buttons">
        {showWeeklyButton && (
          <button 
            className="header-button" 
            onClick={() => navigate('/weekly-menu')}
          >
            Weekly Menu
          </button>
        )}
        <button 
          className="header-button" 
          onClick={() => navigate('/hours')}
        >
          Hours
        </button>
      </div>
    </div>
  );
}

export default HeaderComponent;